import { Component, OnInit } from '@angular/core';
import { UtilityServicesService } from 'src/app/services/utility-service/utility-services.service';
import { FormControl, Validators } from '@angular/forms';
import { UserServicesService } from 'src/app/services/user-service/user-services.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-portal-link',
  templateUrl: './portal-link.component.html',
  styleUrls: ['./portal-link.component.scss']
})
export class PortalLinkComponent implements OnInit {

  portalinfo: any;
  emailinfo: any;
  emailExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  email = new FormControl('', [Validators.required, Validators.pattern(this.emailExp)]);
  flag: boolean;

  constructor(
    private utilityservice: UtilityServicesService,
    private userServices: UserServicesService,
    private router: Router
 
  ) {
  }

  getErrorForEmail() {
    return this.email.hasError('required') ? 'Email can\'t be blank' :
      this.email.hasError('email') ? 'Please provide proper email' :
        this.email.hasError('pattern') ? 'Invalid email' : '';
  }

  ngOnInit() {
    console.log("In portal link")
    this.getData()
  }

  getData() {
    this.utilityservice.getPortalData().subscribe(response => {
     // console.log(response)
      this.portalinfo = response['portaldata']
      this.emailinfo = response['emailcontent']


    }
    );
  }

  newLink() {


    //let selectedEmail = this.jobApplication.controls['email'].value.trim();
    // console.log("email required: ", selectedEmail);
    let selectedEmail = this.email.value.trim();
    let options = {
      purpose: '/users/' + selectedEmail
    }
    //   if (selectedEmail != '') {
    this.userServices.getWithoutTokens(options).subscribe(
      response => {

       this.newLink1();
     
      },
      error => {
      //  console.log("error after service call:142 ", error);
        window.location.href = 'https://economictimes.indiatimes.com/etcampusstars/registration';
        //this.router.navigate(['not-found']);

      }
    )
    }

    newLink1() {
      try {
        if(this.email.value === '' || this.email.value === undefined) throw 'Email is required'
        let data = {
          emailId: this.email.value,
        }
        let options = {
          purpose: '/campaign/dashboard/user/portal/register/mcq',
          data: data
        }
      //  console.log("data to be sent: ", options);
  
        this.userServices.getWithParamsWithoutTokens(options).subscribe(
          response => {
            //console.log("response after sending email: ", response);
            this.utilityservice.openSnackBar((response as any).message)
            this.email.reset();
          },
          error => {
            //console.log("response after sending email: ", error);
            this.utilityservice.openSnackBar((error as any).message)
           // this.router.navigate(['thank-you1']);
           // window.location.href='https://www.google.com';
          }
        )
      } catch (error) {
        this.utilityservice.openSnackBar(error);
      }
    }



}

